import { memo } from 'react'
import classNames from 'classnames'

import { TableDataViewCol, TableDataViewRow } from '@aytm/app/stats/page/question-views/components/table/types'

import Table from '@aytm/app/stats/page/question-views/components/table/Table'
import TableCellTitle from '@aytm/app/stats/page/question-views/components/table/cells/TableCellTitle'
import TableCellValue from '@aytm/app/stats/page/question-views/components/table/cells/TableCellValue'
import TableCellProgress from '@aytm/app/stats/page/question-views/components/table/cells/TableCellProgress'

// styles
import style from '@aytm/app/stats/page/question-views/components/table/styles/Table.module.scss'

type TableRowProps = { cols: TableDataViewCol[]; row: TableDataViewRow }

export default memo(TableRow)
export function TableRow(props: TableRowProps) {
  const renderCell = (cell: TableDataViewCol, index: number) => {
    switch (cell.type) {
      case 'title': {
        return (
          <TableCellTitle
            key={`table-row-cell-${index + 1}`}
            cell={props.row.cells[index]}
            width={'width' in cell ? cell.width : null}
            position={props.row.position}
          />
        )
      }
      case 'value': {
        return (
          <TableCellValue
            key={`table-row-cell-${index + 1}`}
            cell={props.row.cells[index]}
            width={'width' in cell ? cell.width : null}
            position={props.row.position}
            format={'format' in cell ? cell.format : null}
          />
        )
      }
      case 'progress': {
        return (
          <TableCellProgress
            key={`table-row-cell-${index + 1}`}
            cell={props.row.cells[index]}
            width={'width' in cell ? cell.width : null}
          />
        )
      }
      default: {
        return <></>
      }
    }
  }

  return 'data' == props.row.type || !('type' in props.row) ? (
    <>
      <div
        className={classNames(style.row, { [style['row-disabled']]: 'disabled' in props.row && props.row.disabled })}
      >
        {props.cols.map((cell, index) =>
          'cols' in cell ? cell.cols.map((_cell, _index) => renderCell(_cell, index + _index)) : renderCell(cell, index)
        )}
      </div>
      {'table' in props.row ? <Table {...props.row.table} /> : null}
    </>
  ) : 'type' in props.row && 'gap' == props.row.type ? (
    <div className={classNames(style.row, style['row-gap'])}></div>
  ) : null
}
